import {ApiInterceptorService} from '../../../../projects/shared-lib/src/lib/interceptors/api-interceptor.service';
import {AuthInterceptorService} from '../../../../projects/shared-lib/src/lib/interceptors/auth-interceptor.service';
import {SessionSaleInterceptorService} from '../../../../projects/shared-lib/src/lib/interceptors/session-sale.interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {CachingInterceptor} from '../../../../projects/shared-lib/src/lib/interceptors/caching-interceptor.service';
import {RequestCacheWithMap, RequestCache} from "../../../../projects/shared-lib/src/lib/services/request-cache-with-map.service";
import {SessionLocaleService} from "../../../../projects/shared-lib/src/lib/services/session-locale.service";
import {MessageObserverService} from '../../../../projects/shared-lib/src/lib/services/message-observer.service';
import {AuthenticationUserService} from '../../../../projects/shared-lib/src/lib/services/authentication-user.service';

export const SHARED_INTERCEPTORS_SALE: any [] = [
    {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: SessionSaleInterceptorService, multi: true}
];
export const SHARED_INTERCEPTORS_ADMIN: any [] = [
    {provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
];
// export const SHARED_PROVIDE: any [] = [
//     { provide: RequestCacheWithMap, useClass: RequestCacheWithMap, multi: true },
//     { provide: RequestCache, useClass: RequestCache, multi: true },
//     { provide: SessionLocaleService, useClass: SessionLocaleService, multi: true },
//     { provide: MessageObserverService, useClass: MessageObserverService, multi: true },
//     // { provide: AuthenticationUserService, useClass: AuthenticationUserService, multi: true },
//
// ];
export const SHARED_PROVIDE: any [] = [
    RequestCacheWithMap,
    RequestCache,
    SessionLocaleService,
    MessageObserverService,
    AuthenticationUserService
    // { provide: AuthenticationUserService, useClass: AuthenticationUserService, multi: true },

];

